import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { H3, Text } from '../../../elements/typography'
import messages from '../messages'

const ItemText = styled(Text)`
  margin-bottom: ${(props) => props.theme.spacing.xsmall}px;
`

const TypeText = styled(Text)`
  font-size: ${(props) => props.theme.fontSizes.small}px;
`

const ActorFilmography = ({ filmography = [] }) => (
  <>
    <H3>
      <FormattedMessage {...messages.knownFor} />
    </H3>
    {filmography &&
      filmography.map(({ name, type, date }) => (
        <ItemText key={name}>
          {name}{' '}
          <TypeText>
            ({type === 'movie' ? 'Film' : 'TV'}, {date.substr(0, 4)})
          </TypeText>
        </ItemText>
      ))}
  </>
)

export default ActorFilmography
